import { useTranslation } from "react-i18next";
import { handleError } from "../../utils";

export const useErrorHandler = () => {
  const { t } = useTranslation();
  return (error: any) => {
    handleError(error, t);
  };
};